export const sliceText = (text: string, characters: number) => {
  let sliced = text.slice(0, characters);

  if (sliced.length < text.length) {
    sliced += "...";
  }

  return sliced;
};
